export const GET_INSIGHTS_SSO_URL = 'GET_INSIGHTS_SSO_URL'
export const GET_INSIGHTS_DATA = 'GET_INSIGHTS_DATA'
export const GET_INSIGHTS_MAP = 'GET_INSIGHTS_MAP'
export const GET_INSIGHTS_DATA_FULFILLED = 'GET_INSIGHTS_DATA_FULFILLED'
export const GET_INSIGHTS_MAP_FULFILLED = 'GET_INSIGHTS_MAP_FULFILLED'
export const GET_INSIGHTS_MAP_ERROR = 'GET_INSIGHTS_MAP_ERROR'
